import React from "react";
import { DataTypeProvider } from "@devexpress/dx-react-grid";
import moment from "moment-timezone";
import "moment/locale/it";

const TimenozeInMinutes = () => {
  var tz_guess = moment.tz.guess();
  var tz_tm = moment.tz(tz_guess).format("Z");

  var sign = tz_tm.charAt(0);
  var result = tz_tm.substring(1) + ":00";
  var hms = result; // your input string
  var a = hms.split(":"); // split it at the colons
  // Hours are worth 60 minutes.
  var minutes = +a[0] * 60 + +a[1];

  return sign + "" + minutes;
};

moment.locale("it");

function GetBrowser() {
  var name;
  if (
    (navigator.userAgent.indexOf("Opera") ||
      navigator.userAgent.indexOf("OPR")) !== -1
  ) {
    name = "Opera";
  } else if (navigator.userAgent.indexOf("Chrome") !== -1) {
    name = "Chrome";
  } else if (navigator.userAgent.indexOf("Safari") !== -1) {
    name = "Safari";
  } else if (navigator.userAgent.indexOf("Firefox") !== -1) {
    name = "Firefox";
  } else if (
    navigator.userAgent.indexOf("MSIE") !== -1 ||
    !!document.documentMode === true
  ) {
    //IF IE > 10
    name = "IE";
  } else {
    name = "unknown";
  }

  return name;
}


// AG: Recupere il nome del database dal nome dominio
function getDatabaseNameFromHost() {
  const host = window.location.host; // es. "sub.example.com" o "www.sub.example.com"
  const parts = host.split('.').filter(p => p !== 'www'); // rimuove 'www' se presente

  if (parts.length >= 2) {
    console.log(parts);
    return parts[1]; //parts.length - 2]; // es. example in "sub.example.com"
  }

  return null;
}

// AG: Recupere il nome del database dal nome dominio
export function getDatabaseNamePath() {
  
  const pathname = window.location.pathname; // es. www.nome.dominio.it/valderma/auth/login
  const parts = pathname.slice(1).split('/');
  let basePath = parts[0];
  
  if (basePath!='valderma' && basePath!='roydermal' && basePath!='roypet') {
    // window.location.href = '/roydermal';
    // basePath = 'roydermal';
    return getBasename();
  }
  
  return basePath;
}

const getBasename = () => {
  const host = window.location.hostname;

  if (host === 'agenti.roydermal.it') {
    return 'roydermal'; // senza slash iniziale, perché già aggiunto in BrowserRouter
  } else if (host === 'agenti.epspharma.it') {
    return 'valderma';
  } else if (host === 'localhost' || host === '192.168.1.246' || host === 'documenti.epspharma.it') {
    return 'valderma';
  }

  // fallback per sviluppo locale
  return ''; // basename = '/' → rotte normali
};



const config = {
  apiUrl: process.env.REACT_APP_API_URL + "/inc/api/",
  mediaUrl: process.env.REACT_APP_API_URL + "/inc/api/",
  siteUrl: window.location.origin + "/file",
  sitePath: window.location.origin,
  timezone: TimenozeInMinutes(),
  browser: GetBrowser(),
  // Chiave statica di sicurezza (hash SHA-256) inviata nell'header "Authorization" per validare le richieste verso il backend PHP
  keyApi: "922406474ca4705e3f3035831c44449cb811edc1cd751548fef02ad83b4ca6af",
  databaseName: getDatabaseNamePath()
};
export default config;

// Description for auction
export const SetDataTimeZone = (date, format) => {
  function RefreshDataTimeZone(date) {
    var dateType = date;

    var event = new Date(dateType);

    event.setMinutes(TimenozeInMinutes());

    var dateSet = moment(event).format(format);

    return dateSet;
  }

  return RefreshDataTimeZone(date);
};

// from a full date-time-offset ISO8601/RFC3339 value
// console.log(SetDataTimeZone('2017/05/22 02:00', "YYYY-MM-DD HH:mm:ss"))

export const Pad = (n, width, z) => {
  z = z || "0";
  n = n + "";
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
};

export const fullRoles = {
  admin: 1,
  gestore: 12,
  agenteRoypet: 2,
  agenteRoydermal: 3,
  agenteValderma: 11,
  agenteCompleto: 4,
  magazziniere: 5,
  dipendente: 6,
  grafico: 7,
  developer: 8,
  contabile: 9,
};

export const roles = Object.fromEntries(
  Object.entries(fullRoles).filter(([key]) => {
    if (!key.includes('agente')) return true;
    if (config.databaseName=='roydermal' && key.toLowerCase().includes('completo')) return true;
    if (config.databaseName=='roydermal' && key.toLowerCase().includes('roypet')) return true;
    return key == `agente${config.databaseName.charAt(0).toUpperCase() + config.databaseName.slice(1)}`;
  })
);
// console.log(roles);


const camelCaseToString = (str) =>
  str[0].toUpperCase() + str.substring(1).replace(/[A-Z]/g, (l) => " " + l);

  export const roleOptionsForSelect = [
    [0, "Selezionare il ruolo"],
    ...Object.entries(roles)
      // 1. Filtro prima di mappare
      .filter(([key, value]) => {
        if (!key.includes('agente')) return true;
        if (config.databaseName=='roydermal' && key.toLowerCase().includes('completo')) return true;
        if (config.databaseName=='roydermal' && key.toLowerCase().includes('roypet')) return true;
        return key == `agente${config.databaseName.charAt(0).toUpperCase() + config.databaseName.slice(1)}`;
      })
      // 2. Mappa in oggetti con label
      .map(([key, value]) => ({
        key: value,
        label: camelCaseToString(key),
      }))
      // 3. Ordina alfabeticamente
      .sort((a, b) => a.label.localeCompare(b.label))
      // 4. Trasforma in array [value, label]
      .map(({ key, label }) => [key, label])
  ];

export const isAgente = (role) =>
  role === roles.agenteRoydermal ||
  role === roles.agenteRoypet ||
  role === roles.agenteValderma ||
  role === roles.agenteCompleto ||
  role === roles.dipendente;

  // Verifica se l'utente è un agente internalo (admin, developer, magazziniere, contabile, grafico, dipendente)
  // Tipizza la variabile in ingresso come un number
export const isInternalUser = (role) =>
  parseInt(role) === roles.admin ||
  parseInt(role) === roles.gestore ||
  parseInt(role) === roles.developer ||
  parseInt(role) === roles.magazziniere ||
  parseInt(role) === roles.contabile ||
  parseInt(role) === roles.grafico ||
  parseInt(role) === roles.dipendente;

export const colors = {
  admin: "#d95e18",
  gestore: "#d95e18",
  agenteRoypet: "#323e86",
  agenteRoydermal: "#ef233c",
  agenteValderma: "#003366",
  agenteCompleto: "#c72b7d",
  magazziniere: "#2a9d8f",
  dipendente: "#e29578",
  grafico: "#bfcf9c",
  developer: "#333333",
  contabile: "#B89C00",
};

export const statusRichiesta = {
  inAttesa: 0,
  inevaso: 1, // pronto per essere ritirato o spedito
  evaso: 2, // ordine ritirato o spedito
  rifiutato: 3, // cancellato da agente o rifiutato da magazziniere
  approvato: 4, // in caso sia per una vendita (approvata dall'admin)
};

export const statusRichiestaServizio = {
  inAttesa: 0,
  approvato: 1, //
  annullato: 2, // cancellato da agente o rifiutato da magazziniere
};

export const statusRichiestaCalendario = {
  inAttesa: 0,
  approvato: 1, //
  annullato: 2, // cancellato da utente o rifiutato da admin
};

export const categorieFile = {
  rendiconti: 0,
  manuali: 1,
  datiVendita: 2,
  documenti: 3,
};

export const categorieRichiesteCalendario  = {
  ferie: 0,
  permesso: 1,
};

export const fileVisibilityGroups = [
  {
    value: -100,
    label: "Nessuno",
  },
  {
    value: 0,
    label: "Tutti",
  },
  {
    value: -1,
    label: "Gruppo Roydermal",
  },
  {
    value: -2,
    label: "Gruppo Roypet",
  },
  {
    value: -11,
    label: "Gruppo Valderma",
  }
];

export const nomiCategorieFile = {
  0: "rendiconto",
  1: "manuale",
  2: "dati vendite",
  3: "documento",
};
export const nomiCategorieFilePlural = {
  0: "Rendiconti",
  1: "Manuali",
  2: "Dati vendite",
  3: "Documenti",
};

// Sottotipi dei file nella categoria "Manuali"
export const variantiManuale = [
  "manuale",
  "focus",
  "visual",
  "folder",
  "studio-competitors",
];
export const nomiVariantiManuale = {
  manuale: "Manuale",
  focus: "Focus",
  visual: "Visual",
  folder: "Folder",
  "studio-competitors": "Studio Competitors",
};

export const metodiPagamento = {
  1: "Contrassegno alla consegna",
  2: "Bonifico anticipato su ordine",
  3: "Altro (Specificare nelle Note)",  
}

export const createMetodoPagamentoMapping = (roles, role) => {
  const roleValue = parseInt(role, 10);
  const newOptions = { ...metodiPagamento };
  const discounts = { ...scontiMetodiPagamento };

  if (roleValue !== roles.agenteValderma) {
    newOptions[4] = "Bonifico anticipato su ordine +5%";
    discounts[4] = 0.05;
    if (
      (roleValue === roles.agenteCompleto || roleValue === roles.agenteRoypet) &&
      Date.now() < Date.parse("2025-10-13")
    ) {
      newOptions[5] = "Pagamento Anticipato con Carta";
      if (typeof discounts[5] === "undefined") discounts[5] = 0;
    }
  }

  Object.keys(newOptions).forEach((key) => {
    if (typeof discounts[key] === "undefined") discounts[key] = 0;
  });

  Object.defineProperty(newOptions, "discounts", {
    value: discounts,
    enumerable: false,
    configurable: false,
    writable: false,
  });

  return newOptions;
};

// export const metodiPagamento = {
//   1 : "Contrassegno alla consegna",
//   2 : "Bonifico anticipato su ordine",
//   3 : "Bonifico anticipato su ordine +5%",
//   4 : "Altro (Specificare nelle Note)",
//   5 : "Pagamento Anticipato con Carta",
// }

export const scontiMetodiPagamento = {
  1: 0,
  2: 0, 
  3: 0,
  4: 0.05,
  5: 0,
}


export const icons = {
  edit: "/media/svg/icons/Communication/Write.svg",
  delete: "/media/svg/icons/General/Trash.svg",
  addToCart: "/media/svg/icons/Shopping/Cart1.svg",
  close: "/media/svg/icons/Navigation/Close.svg",
  reset: "/media/svg/icons/Media/Repeat.svg",
  go_back: "/media/svg/icons/Navigation/Angle-left.svg",
  ok: "/media/svg/icons/Navigation/Check.svg",
  go: "/media/svg/icons/Communication/Send.svg",
  upload: "/media/svg/icons/Files/Upload.svg",
  //open: "/media/svg/icons/General/Visible.svg",
  download: "/media/svg/icons/Files/Download.svg",
  //preview: "/media/svg/icons/Files/Media.svg",
};


export const videoIcons = {
  learning: "/media/svg/icons/Home/Book-open.svg",
  course: "/media/svg/icons/Media/DVD.svg",
  manage: "/media/svg/icons/General/Settings-2.svg",
  results: "/media/svg/icons/Navigation/Double-check.svg",
  quizBuilder: "/media/svg/icons/Communication/Clipboard-list.svg",
}

export const menuIcons = {
  ai: "/media/svg/icons/Devices/Cardboard-vr.svg",
  ims: "/media/svg/icons/Shopping/Chart-line1.svg",
  centers: "/media/svg/icons/Design/Layers.svg",
  book: "/media/svg/icons/Communication/Adress-book2.svg",
  medics: "/media/svg/icons/Communication/Group.svg",
  calendar: "/media/svg/icons/Layout/Layout-grid.svg",
  dashboard: "/media/svg/icons/Layout/Layout-4-blocks.svg",
  events: "/media/svg/icons/Layout/Layout-grid.svg", //"/media/svg/icons/Home/Clock.svg",
  files: "/media/svg/icons/Home/Commode1.svg",
  admin: "/media/svg/icons/General/Settings-1.svg", //"/media/svg/icons/Communication/Group.svg",
  mail: "/media/svg/icons/Communication/Mail.svg",
  magazzino: "/media/svg/icons/Shopping/Loader.svg",
  products: "/media/svg/icons/Shopping/Barcode.svg",
  cart: "/media/svg/icons/Shopping/Cart1.svg",
  campioni: "/media/svg/icons/Shopping/Box2.svg",
  marketing_material: "/media/svg/icons/Home/Book-open.svg",
  status: "/media/svg/icons/Shopping/Loader.svg",
  services: "/media/svg/icons/Home/Earth.svg",
  selling: "/media/svg/icons/Shopping/Euro.svg",
  clients: "/media/svg/icons/Communication/Group.svg",
  list: "/media/svg/icons/Communication/Clipboard-list.svg",
};


// Colonna Data formattata
export const DateFormattedColumn = ({ for: columnNames }) => (
  <DataTypeProvider
    for={columnNames}
    formatterComponent={({ value }) => moment(value).format("DD MMMM YYYY")}
  />
);

